import styled from "styled-components";
import { flex, flexBetweenCenter, flexColumnBetween, flexEnd, flexUnsetCenter } from "./mixins";

export const CommonLayout = styled.div`
  min-height: calc(100vh - 4.25rem);
  padding: 1.875rem 3.125rem;
`;

export const CommmonBox = styled.div`
  background: #fff;
  padding: 1.875rem;
  border: 1px solid #CFCFCF;
  border-radius: 0.375rem;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
`;

export const CommmonBoxLayout = styled(CommmonBox)`
  min-height: calc(100vh - 8rem);
`;

export const CommonBoxTitle = styled.h2`
  color: #4B5476;
  font-size: 1.125rem;
  font-weight: 700;
  padding-bottom: 0.875rem;
  border-bottom: 2px solid #E6E9ED;
  margin-bottom: 1rem;
`;

export const FlexColBetweenBox = styled.div`
  min-height: calc(100vh - 12rem);
  ${flexColumnBetween};
`; 

export const CommonFooter = styled.div`
  padding-top: 1rem;
  border-top: 2px solid #E6E9ED;
  margin-top: 2rem;
  ${flexBetweenCenter};
`;

export const SearchBox = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  ${flexEnd};
  gap: 0.625rem;
`;

export const FlexBox = styled.div`
  ${flex};
`;

export const BoxButtonTitle = styled(CommonBoxTitle)`
  ${flexBetweenCenter};
`;

export const BtnBox = styled.div`
  ${flex};
  gap: 0.625rem;
`;

// 테이블 디자인 변경
export const MailYesNoTd = styled.td<{ $mail: number | undefined | boolean; }>`
  ${({ $mail }) => $mail !== 3 && `color: #FF4B4B !important;`}
`;

export const TitleTd = styled.td<{ $titleWit: string; }>`
  width: ${({ $titleWit }) => $titleWit};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TableLayout = styled.div`
  min-height: 700px;
  ${flexColumnBetween};
`;

export const TrPointer = styled.tr`
  cursor: pointer;
`;

export const LinkTd = styled.td`
  cursor: pointer;
`;

// input 관련 스타일
export const InputTitle = styled.h6`
  color: #263439;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: -0.28px;
  width: 7rem;
  margin-right: 0.25rem;
  ${flexUnsetCenter};
`;

export const InputLinkBox = styled(FlexBox)`
  margin-bottom: 0.75rem;
  ${flex};
  gap: 5%;
`;

export const DetailInfoBox = styled.div`
  height: 3rem;
  border-top: 2px solid #E6E9ED;
  border-bottom: 2px solid #E6E9ED;
  ${flex};

  div {
    color: #73879C;
    font-size: 0.875rem;
    font-weight: 500;
    padding: 0 0.75rem;
    border-right: 1px solid #E6E9ED;
    ${flexUnsetCenter};
  }
`;

// 디테일 관련
export const ContentBox = styled.div`
  padding: 1rem;
  min-height: 500px;
  height: calc(100vh - 444px);
  overflow: auto;
`;